import React, {useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";
import ContentBox from "../../../../../../components/content-box/ContentBox";
import PageActions from "../../../../../base/PageActions";
import Breadcrumbs from "../../../../../../components/breadcrumbs/Breadcrumbs";
import ImageLink from "../../../../../../components/image-link/ImageLink";
import _naming_service from "../../../../../../services/NamingService";
import _http_service from "../../../../../../services/HttpService";
import _image_service from "../../../../../../services/ImageService";
import '../../../../../styles/Common.scss';
import '../../WorldPages.scss';
import './WorldBestiarySubsectionPage.scss';

interface WorldBestiarySubsectionPageProps {
}

const WorldBestiarySubsectionPage = (props: WorldBestiarySubsectionPageProps) => {

    const subsection: string = useParams()['subsection'] || '';
    
    const page: PageActions = new PageActions({
        title: `Casarok Bestiary: ${_naming_service.capitalizeName(subsection)} - Chase the Fox`,
        description: `Learn about ${_naming_service.capitalizeName(subsection)} in Chase's world through the Casarok bestiary!`,
        keywords: ["casarok", "bestiary", "fantasy race", "fantasy world", subsection],
        imgSrc: `chase/world/bestiary/${subsection}.png`,
        url: `world/bestiary/${subsection}`
    });

    const [entries, setEntries] = React.useState<string[]>([]);

    const navigateTo = useNavigate();

    useEffect(() => {
        _http_service.getWorldTopics(subsection)
            .then(data => setEntries(data))
            .catch(() => navigateTo("/error", {replace: true}));
    }, []);

    const normalizeEntryName = (name: string): string => {
        return name.toLowerCase().replace(/[ ']/g, "-").replace(/š/g, 's');
    }

    return page.generateMetaContent(
        <>
            <ContentBox header={`${_naming_service.capitalizeName(subsection)}s`}>
                <Breadcrumbs path={page.getUrl()}/>
                <div className="world-page-static">
                    <ul className="bestiary-subsection-list">
                        {entries.map((entry) => (
                            <li className=""
                                key={`bestiary-${subsection}-${normalizeEntryName(entry)}`}>
                                <ImageLink className="world-link"
                                           imgSrc={_image_service.getCdnImageSrc(`chase/world/bestiary/${subsection}/${normalizeEntryName(entry)}.png`)}
                                           linkUrl={`/world/bestiary/${subsection}/${normalizeEntryName(entry)}`}
                                           linkName={_naming_service.capitalizeName(entry)}/>
                            </li>
                        ))}
                    </ul>
                </div>
            </ContentBox>
        </>
    );
}

export default WorldBestiarySubsectionPage;